<template>
  <div class="chinese-medicinal" v-if="cartList.length">
    <div class="chinese-medicinal-tips">以下为单剂中药用量：</div>
    <div class="list">
      <div v-for="(item, index) in cartList" :key="index">
        <div class="list-name">{{item.commonName}}</div>
        <div class="list-bottom">
          <van-icon @click="deleteSelect(index)" name="delete" size="22" color="#999"/>
          <div class="list-weight">
            <van-stepper
                v-model="item.quantity"
                min="0"
                max="999"
                input-width="50"
                @blur="changeDrug(item, index)"
            />
            <span>g</span>
          </div>
        </div>
      </div>
    </div>
    <div class="medicinal-nums">
      <div class="medicinal-nums-contain">
        共<span class="red" v-show="inquiryType==1">*</span>
        <van-field v-model.number="dosageAndUsage.tcmTotalDosage" @input="inputNum('tcmTotalDosage')" type="number" input-align="center" class="medicinal-nums-input"/>
        剂，每日
        <van-field v-model.number="dosageAndUsage.tcmDailyDosage" @input="inputNum('tcmDailyDosage')" type="number" input-align="center" class="medicinal-nums-input"/>
        剂，每剂分
        <van-field v-model.number="dosageAndUsage.tcmDailyFrequency" @input="inputNum('tcmDailyFrequency')" type="number" input-align="center" class="medicinal-nums-input"/>
        次用药
      </div>
    </div>
    <div class="usage" @click="usageShow = true">
      <span class="usage-title">用法</span>
      <span class="grey">{{dosageAndUsage.tcmUsage ? dosageAndUsage.tcmUsage : "请选择用法"}}</span>
      <van-icon name="arrow" size="18" color="#999"/>
    </div>
    <van-action-sheet v-model="usageShow" title="用法">
      <div class="content">
        <ul>
          <li @click="usageSelect(item)" class="usageList" v-for="(item, index) in usageList" :key="index">
            <span>{{item.tcmUsage}}</span>
            <van-icon v-show=" dosageAndUsage.tcmUsage === item.tcmUsage" style="margin-left: 10px;" name="success" size="22" color="#01B956"/>
          </li>
        </ul>
      </div>
    </van-action-sheet>
    <div class="processed" @click="processedShow = true">
      <span class="processed-title">加工方式</span>
      <span class="grey">{{dosageAndUsage.tcmProcessingMethod ? dosageAndUsage.tcmProcessingMethod : "请选择加工方式"}}</span>
      <van-icon name="arrow" size="18" color="#999"/>
    </div>
    <van-action-sheet v-model="processedShow" title="加工方式">
      <div class="content">
        <ul>
          <li @click="processedSelect(item)" class="processedList" v-for="(item, index) in processedList" :key="index">
            <span>{{item.tcmProcessingMethod}}</span>
            <van-icon v-show=" dosageAndUsage.tcmProcessingMethod === item.tcmProcessingMethod" style="margin-left: 10px;" name="success" size="22" color="#01B956"/>
          </li>
        </ul>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
import {
  chineseHerbology,
} from "@/api/index";
export default {
  props:['cartList','medicineParamsCn','inquiryType'],
  data() {
    return {
      dosageAndUsage:{
        tcmTotalDosage:this.medicineParamsCn.tcmTotalDosage|| '', // 总计
        tcmDailyDosage: this.medicineParamsCn.tcmDailyDosage||'', // 每日几剂
        tcmDailyFrequency: this.medicineParamsCn.tcmDailyFrequency||'', // 每剂几次
        tcmUsage: this.medicineParamsCn.tcmUsage||'',
        tcmProcessingMethod: this.medicineParamsCn.tcmProcessingMethod||'',
      },
      
      usageShow: false, // 用法
      usageList: [],
      processedShow: false, // 加工方式
      processedList: [],
      
    }
  },
  created() {
    this.updataSelectVal(1)
    this.updataSelectVal(2)
  },
  watch:{
    cartList:{
      handler(val){
        console.error('绑定',val)
        // this.$set(this.cartList,val)
      }
    },
    deep:true,
    immediate:true,
    medicineParamsCn:{
      handler(val){
        this.dosageAndUsage = val
      }
    },
    deep:true,
    immediate: true
  },
  methods: {
    async updataSelectVal(val) {
      try {
        const res = await chineseHerbology({type: val})
          if (res.data.code === 0) {
            if (val === 1) {
              this.usageList = res.data.data
            } else if (val === 2) {
              this.processedList = res.data.data
            }
          }
      } catch (error){
        console.log('更新用法、加工方式', error);
      }
    },
    inputNum(type) {
      switch (type){
        case 'tcmTotalDosage':
          this.dosageAndUsage.tcmTotalDosage < 0 ? this.dosageAndUsage.tcmTotalDosage = 0 : ''
          this.dosageAndUsage.tcmTotalDosage > 30 ? this.dosageAndUsage.tcmTotalDosage = 30 : ''
          break
        case 'tcmDailyDosage':
          if (this.dosageAndUsage.tcmDailyDosage === '') {
            this.dosageAndUsage.tcmDailyDosage = ''
          } else {
            this.dosageAndUsage.tcmDailyDosage < 1 ? this.dosageAndUsage.tcmDailyDosage = 1 : ''
          }
          this.dosageAndUsage.tcmDailyDosage > 999 ? this.dosageAndUsage.tcmDailyDosage = 999 : ''
          break
        case 'tcmDailyFrequency':
          this.dosageAndUsage.tcmDailyFrequency < 0 ? this.dosageAndUsage.tcmDailyFrequency = 0 : ''
          this.dosageAndUsage.tcmDailyFrequency > 999 ? this.dosageAndUsage.tcmDailyFrequency = 999 : ''
          break
      }
      this.$emit("updateDosageAndUsage", this.dosageAndUsage)
    },
    /**
     * @description: 用法
     * @param {}
     * @return:
     */
    usageSelect(item) {
      this.usageShow = false
      this.dosageAndUsage.tcmUsage = item.tcmUsage
      this.$emit("updateDosageAndUsage", this.dosageAndUsage) // 修改
    },
    /**
     * @description: 加工方式
     * @param {}
     * @return:
     */
    processedSelect(item) {
      this.processedShow = false
      this.dosageAndUsage.tcmProcessingMethod = item.tcmProcessingMethod
      // this.$emit("updateDosageAndUsage", this.dosageAndUsage) // 修改
    },
    /**
     * @description: 删除父组件中的中药
     * @param {}
     * @return:
     */
    deleteSelect(index){
      const pref = this.cartList[index].pref
      this.cartList.splice(index, 1)
      this.$emit("upDateMedicineCn", pref) // 向上级暴露，删除父组件的中药
    },
    /**
     * @description: input change
     * @param {}
     * @return:
     */
    changeDrug(item, index) {
      this.$nextTick(()=>{
        item.quantity == 0 ? this.deleteSelect(index) : this.$emit("upDateMedicineCn", item.pref, false);
      })
    }
  }
};
</script>

<style scoped lang="scss">
  *{
    box-sizing: border-box;
  }
  .chinese-medicinal{
    padding: 0 11px 0 15px;
    font-size: 14px;
    .chinese-medicinal-tips{
      margin-bottom: 10px;
      margin-top: 10px;
      font-size: 15px;
      color: #4A4A4A;
    }
    .list{
      display: flex;
      flex-wrap: wrap;
      justify-content:space-between;
      border-bottom: 1px solid #f7f7f7;
      padding-bottom: 10px;
      margin-bottom: 12px;
      >div{
        width: 48%;
        height: 75px;
        background: #fff;
        border: 1px solid #f0f0f0;
        border-radius: 9px;
        margin-bottom: 10px;
        padding: 10px;
        display: flex;
        flex-wrap: wrap;
        justify-content:space-between;
        .list-name{
          width: 100%;
          margin-bottom: 8px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
        .list-bottom{
          display: flex;
          width: 100%;
          align-items: center;
          .list-weight{
            flex-grow:1;
            display: flex;
            justify-content:flex-end;
            /deep/ .van-stepper__minus, /deep/ .van-stepper__plus{
              display: none;
            }
            /deep/ .van-stepper__input{
              width: 50px;
              height: 25px;
              padding: 0;
              border-bottom: 1px solid #d8d8d8;
              background: transparent;
            }
            //.list-input{
            //  width: 50px;
            //  padding: 0;
            //  border-bottom: 1px solid #d8d8d8;
            //}
          }
        }
      }
    }
    .medicinal-nums{
      padding: 0 0 15px 0;
      border-bottom: 1px solid #f7f7f7;
      .red{
        color: #FF3B30;
      }
      .medicinal-nums-title{
        margin-bottom: 8px;
      }
      .medicinal-nums-contain{
        display: flex;
        flex-wrap: wrap;
        //flex-shrink: 0;
        //padding-left: 7px;
        vertical-align:bottom;
        line-height: 24px;
        /deep/ .van-field__control {
          color: #01B956;
        }
        .medicinal-nums-input{
          width: 35px;
          padding: 0;
          border-bottom: 1px solid #d8d8d8;
          min-height:auto!important;
          padding-right:0!important;
        }
      }
    }
    .usage,.processed{
      padding: 15px 0;
      display: flex;
      justify-content:space-between;
      .usage-title,.processed-title{
        width: 89px;
        white-space: nowrap;
      }
      .grey{
        padding-left:10px;
        flex-grow: 1;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .usageList,.processedList {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 52.5px;
      line-height: 52.5px;
      font-size: 16px;
      color: #222;
      text-align: center;
      >span{
        width: 80%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
</style>
